var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParasitesViewEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#ff75b0;}.cls-3{fill:#ffaed9;}.cls-4{fill:#fce3f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.28,
    y: 0.23,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.28,
    y: 0.23,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "parasites_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.1,1.55a17,17,0,0,0-17,16.88V429.27a17,17,0,0,0,17,16.88H582a17,17,0,0,0,17-16.88V18.43A17,17,0,0,0,582,1.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 108.03,
    y: 77.7,
    width: 380.92,
    height: 444.6,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.2,271.76V583.51a17,17,0,0,1-17.26,16.72H17.53A17,17,0,0,1,.28,583.51V172.35a17,17,0,0,1,17.25-16.72H261.32a17.7,17.7,0,0,1,5.85,1L379.64,264.84A16.14,16.14,0,0,1,381.2,271.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.43,263.83h-95A17.2,17.2,0,0,1,266,246.88V155.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.69,
    y: 372.31,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.94 1.41) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.8,
    y: 517.89,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.04 0.94) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.13,
    y: 299.76,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.39 1.41) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.24,
    y: 444.86,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.49 1.42) rotate(-0.43)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParasitesViewEntries);
export default __webpack_public_path__ + "static/media/parasites_view_entries.342f16cf6825b13d53c0492694e70f55.svg";
export { ForwardRef as ReactComponent };